import './App.css'
import BallisticsCalculator from './components/BallisticCalculator'

function App() {
  return (
    <>
<BallisticsCalculator />
    </>
  )
}

export default App
